<template>
  <div>
    <ExtEnvComponent></ExtEnvComponent>
    <CRow>
      <CCol col="12">
        <CCard>
          <CCardBody class="p-2">
            <CForm inline>
              <label class="col-form-label ml-2 mr-2">검색조건</label>
              <CSelect
                :value.sync="inFacilityId"
                :options="inFacilityList"
                style="margin-bottom: 0; width: 97%"
                class="ml-2 ml-sm-0 w-auto-sm"
              >
              </CSelect>

              <div
                role="group"
                class="form-group form-row ml-2 mt-2 mt-sm-0 w-100 w-auto-sm"
              >
                <v-date-picker
                  v-model="searchAtRange"
                  is-range
                  :max-date="getMaxDate()"
                  :masks="{ title: 'YYYY년 MMM', L: 'YYYY-MM-DD' }"
                  class="w-100"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <div class="w-100 flex justify-center items-center">
                      <input
                        :value="inputValue.start"
                        v-on="inputEvents.start"
                        class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                        style="height: 35px; width: 47%"
                      />
                      ~
                      <input
                        :value="inputValue.end"
                        v-on="inputEvents.end"
                        class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                        style="height: 35px; width: 47%"
                      />
                    </div>
                  </template>
                </v-date-picker>
              </div>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol col="12">
        <CCard>
          <CCardBody class="p-2">
            <CTabs :active-tab.sync="tab">
              <CTab title="실내부" active>
                <div class="p-2">
                  <div
                    ref="inEnvChart"
                    style="width: 100%; height: 400px"
                    :class="
                      chart.inEnv == null || chart.inEnv.data.length === 0
                        ? 'd-none'
                        : ''
                    "
                  ></div>
                  <div
                    style="
                      width: 100%;
                      height: 400px;
                      display: flex;
                      justify-content: center;
                      flex-direction: column;
                      text-align: center;
                      font-weight: bold;
                      font-size: 150%;
                      color: #ff0d0d;
                    "
                    v-if="chart.inEnv == null || chart.inEnv.data.length === 0"
                  >
                    <div>
                      <i class="fa fa-times-circle" aria-hidden="true"></i>
                      데이터 없음
                    </div>
                  </div>
                </div>
              </CTab>
              <CTab title="근권부">
                <div class="p-2">
                  <div
                    ref="rootEnvChart"
                    style="width: 100%; height: 400px"
                    :class="
                      chart.rootEnv == null || chart.rootEnv.data.length === 0
                        ? 'd-none'
                        : ''
                    "
                  ></div>
                  <div
                    style="
                      width: 100%;
                      height: 400px;
                      display: flex;
                      justify-content: center;
                      flex-direction: column;
                      text-align: center;
                      font-weight: bold;
                      font-size: 150%;
                      color: #ff0d0d;
                    "
                    v-if="
                      chart.rootEnv == null || chart.rootEnv.data.length === 0
                    "
                  >
                    <div>
                      <i class="fa fa-times-circle" aria-hidden="true"></i>
                      데이터 없음
                    </div>
                  </div>
                </div>
              </CTab>
              <CTab title="양액부">
                <div class="p-2">
                  <div
                    ref="nutrientSolutionChart"
                    style="width: 100%; height: 400px"
                    :class="
                      chart.nutrientSolution == null ||
                      chart.nutrientSolution.data.length === 0
                        ? 'd-none'
                        : ''
                    "
                  ></div>
                  <div
                    style="
                      width: 100%;
                      height: 400px;
                      display: flex;
                      justify-content: center;
                      flex-direction: column;
                      text-align: center;
                      font-weight: bold;
                      font-size: 150%;
                      color: #ff0d0d;
                    "
                    v-if="
                      chart.nutrientSolution == null ||
                      chart.nutrientSolution.data.length === 0
                    "
                  >
                    <div>
                      <i class="fa fa-times-circle" aria-hidden="true"></i>
                      데이터 없음
                    </div>
                  </div>
                </div>
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import core from "@/core";
import SensorService from "@/services/sensor/sensor.service";
import store from "@/store";
import ExtEnvComponent from "@/components/monitoring/ExtEnvComponent";
import MixinsInFacility from "@/mixins/in-facility";

export default {
  name: "Integrated",
  components: { ExtEnvComponent },
  mixins: [MixinsInFacility()],
  data() {
    return {
      tab: 0,
      chart: {
        inEnv: null,
        rootEnv: null,
        nutrientSolution: null,
      },
      searchAtRange: {
        start: new Date(),
        end: new Date(),
      },
    };
  },
  watch: {
    tab() {
      console.log(this.tab);
      this.getSensorData();
    },
    searchAtRange() {
      this.getSensorData();
    },
    inFacilityId() {
      const inFacilityId = this.inFacilityId;
      console.log("changed inFacilityId : ", inFacilityId);
      if (inFacilityId != null) {
        this.getSensorData();
      }
    },
    "chart.inEnv.data"() {
      console.log("내부 환경센서 데이터 변경");
    },
    "chart.rootEnv.data"() {
      console.log("근권부 환경센서 데이터 변경");
    },
    "chart.nutrientSolution.data"() {
      console.log("양액 환경센서 데이터 변경");
    },
  },
  methods: {
    async getSensorData() {
      const inFacilityId = this.inFacilityId;
      if (inFacilityId != null) {
        core.loader.show();

        const standardMoment = core.date.instance(this.searchAtRange.start);
        const endMoment = core.date
          .instance(this.searchAtRange.end)
          .add(1, "days");

        console.log("standardMoment : ", standardMoment.format("YYYY-MM-DD"));
        if (this.tab === 0) {
          if (this.chart.inEnv == null) {
            this.createInEnvChart();
          }
          const list = await SensorService.getInEnvList({
            inFacilityId: inFacilityId,
            sensingAtGreaterThanEqual: standardMoment.format("YYYY-MM-DD"),
            sensingAtLessThan: endMoment.format("YYYY-MM-DD"),
          });
          list.forEach((sensor) => {
            sensor.date = core.date.instance(sensor.sensingAt).toDate();
          });
          this.chart.inEnv.data = list;
        } else if (this.tab === 1) {
          if (this.chart.rootEnv == null) {
            this.createRootEnvChart();
          }
          const list = await SensorService.getRootEnvList({
            inFacilityId: inFacilityId,
            sensingAtGreaterThanEqual: standardMoment.format("YYYY-MM-DD"),
            sensingAtLessThan: endMoment.add(1, "days").format("YYYY-MM-DD"),
          });
          list.forEach((sensor) => {
            sensor.date = core.date.instance(sensor.sensingAt).toDate();
          });
          this.chart.rootEnv.data = list;
        } else if (this.tab === 2) {
          if (this.chart.nutrientSolution == null) {
            this.createNutrientSolutionChart();
          }
          const list = await SensorService.getNutrientSolutionList({
            inFacilityId: inFacilityId,
            sensingAtGreaterThanEqual: standardMoment.format("YYYY-MM-DD"),
            sensingAtLessThan: endMoment.add(1, "days").format("YYYY-MM-DD"),
          });
          list.forEach((sensor) => {
            sensor.date = core.date.instance(sensor.sensingAt).toDate();
          });
          this.chart.nutrientSolution.data = list;
        } else {
          console.log("Unknown tab : ", this.tab);
        }
        core.loader.hide();
      }
    },
    getMaxDate() {
      return core.date.instance().add(1, "days").toDate();
    },
    createInEnvChart() {
      const $el = this.$refs.inEnvChart;
      const chart = core.amchart.createXYDateChart($el);

      const seriesList = [];
      const dateFieldName = "date";
      const toggleAllSeries = core.amchart.createLineSeries(
        chart,
        "void",
        dateFieldName,
        "Toggle All",
        "#3e3e3e",
      );
      toggleAllSeries.events.on("hidden", function () {
        seriesList.forEach((series) => {
          series.hide();
        });
      });
      toggleAllSeries.events.on("shown", function () {
        seriesList.forEach((series) => {
          series.show();
        });
      });
      const series1 = core.amchart.createLineSeries(
        chart,
        "temp",
        dateFieldName,
        "온도",
        "#ff6600",
        "℃",
      );
      seriesList.push(series1);

      const series2 = core.amchart.createLineSeries(
        chart,
        "humidity",
        dateFieldName,
        "습도",
        "#1495ff",
        "%",
      );
      seriesList.push(series2);
      const series3 = core.amchart.createLineSeries(
        chart,
        "co2",
        dateFieldName,
        "co2",
        "#56a70f",
        "ppm",
      );
      seriesList.push(series3);
      const series4 = core.amchart.createLineSeries(
        chart,
        "solarRadiation",
        dateFieldName,
        "일사량",
        "#790cb1",
        "",
      );
      seriesList.push(series4);

      const scrollbarX = new am4core.Scrollbar();
      chart.legend = new am4charts.Legend();
      chart.cursor = new am4charts.XYCursor();
      chart.scrollbarX = scrollbarX;

      chart.data = null;


      // // 매우 많은 증산
      // addChartRange(40, 45, "#f2951c");
      // series1.stroke = am4core.color("#ff6600");
      // series1.fill = am4core.color("#ff6600");
      this.chart.inEnv = chart;
    },
    createRootEnvChart() {
      const $el = this.$refs.rootEnvChart;
      const chart = core.amchart.createXYDateChart($el);

      const seriesList = [];
      const dateFieldName = "date";
      const toggleAllSeries = core.amchart.createLineSeries(
        chart,
        "void",
        dateFieldName,
        "Toggle All",
        "#3e3e3e",
      );
      toggleAllSeries.events.on("hidden", function () {
        seriesList.forEach((series) => {
          series.hide();
        });
      });
      toggleAllSeries.events.on("shown", function () {
        seriesList.forEach((series) => {
          series.show();
        });
      });
      const series1 = core.amchart.createLineSeries(
        chart,
        "temp",
        dateFieldName,
        "온도",
        "#ff6600",
        "℃",
      );
      seriesList.push(series1);

      const series2 = core.amchart.createLineSeries(
        chart,
        "humidity",
        dateFieldName,
        "습도",
        "#1495ff",
        "%",
      );
      seriesList.push(series2);
      const series3 = core.amchart.createLineSeries(
        chart,
        "drainageEc",
        dateFieldName,
        "배액 EC",
        "#56a70f",
        "",
      );
      seriesList.push(series3);
      const series4 = core.amchart.createLineSeries(
        chart,
        "drainagePh",
        dateFieldName,
        "배액 PH",
        "#790cb1",
        "",
      );
      seriesList.push(series4);

      const scrollbarX = new am4core.Scrollbar();
      chart.legend = new am4charts.Legend();
      chart.cursor = new am4charts.XYCursor();
      chart.scrollbarX = scrollbarX;

      chart.data = null;

      this.chart.rootEnv = chart;
    },
    createNutrientSolutionChart() {
      const $el = this.$refs.nutrientSolutionChart;
      const chart = core.amchart.createXYDateChart($el);

      const seriesList = [];
      const dateFieldName = "date";
      const toggleAllSeries = core.amchart.createLineSeries(
        chart,
        "void",
        dateFieldName,
        "Toggle All",
        "#3e3e3e",
      );
      toggleAllSeries.events.on("hidden", function () {
        seriesList.forEach((series) => {
          series.hide();
        });
      });
      toggleAllSeries.events.on("shown", function () {
        seriesList.forEach((series) => {
          series.show();
        });
      });
      const series1 = core.amchart.createLineSeries(
        chart,
        "ec",
        dateFieldName,
        "EC",
        "#ff6600",
        "",
      );
      seriesList.push(series1);
      const series2 = core.amchart.createLineSeries(
        chart,
        "ph",
        dateFieldName,
        "PH",
        "#1495ff",
        "",
      );
      seriesList.push(series2);
      const series3 = core.amchart.createLineSeries(
        chart,
        "flowRate",
        dateFieldName,
        "공급유량",
        "#56a70f",
        "",
      );
      seriesList.push(series3);
      const series4 = core.amchart.createLineSeries(
        chart,
        "constConcen",
        dateFieldName,
        "공급성분농도",
        "#790cb1",
        "",
      );
      seriesList.push(series4);

      const scrollbarX = new am4core.Scrollbar();
      chart.legend = new am4charts.Legend();
      chart.cursor = new am4charts.XYCursor();
      chart.scrollbarX = scrollbarX;

      chart.data = null;

      this.chart.nutrientSolution = chart;
    },
  },
};
</script>
